module.exports = __webpack_public_path__ + "img/semp-logo.383005c3.svg";